import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Asset } from '../services/assetListService'

export interface KpiAssetState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  assets: Asset[]
}

const initialState: KpiAssetState = {
  isLoading: true,
  error: null,
  httpStatus: null,
  assets: []
}

const kpiAssetListSlice = createSlice({
  name: 'kpiAssetListSlice',
  initialState,
  reducers: {
    kpiAssetListLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        assets: []
      }
    },
    kpiAssetListUpdateAction: (state, action: PayloadAction<{ data: { assets?: Asset[] }, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        assets: action.payload.data.assets ?? []
      }
    },
    kpiAssetListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        assets: []
      }
    }
  }
})

export const {
  kpiAssetListLoadingAction,
  kpiAssetListUpdateAction,
  kpiAssetListErrorAction
} = kpiAssetListSlice.actions

export default kpiAssetListSlice.reducer
